import {getFunctions, httpsCallable} from "firebase/functions";
export default {
  state: {
    loading: false,
    error: null,
    listingData: null,
    listingItems: null,
    activeListingId: null
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setListingItems (state, payload) {
      state.listingItems = payload
    },
    clearError (state) {
      state.error = null
    },
    setListingData (state, payload) {
      state.listingData = payload
      state.activeListingId = payload.id
    }
  },
  actions: {
    clearError ({commit}) {
      commit('clearError')
    },
    setError ({commit}, payload) {
      commit('setError', payload)
    },
    setLoading ({commit}, payload) {
      commit('setLoading', payload)
    },
    setListingData ({commit}, payload) {
      commit('setListingData', payload)
    },
    setListingItems ({commit}, payload) {
      commit('setListingItems', payload)
    },
    // getListingItems ({commit}, payload) {
    //   commit('setListingItems', payload)
    // }
    coldStartCloudFunctions () {
      const functions = getFunctions()
      let itemData = {
        locations: [
          {
            created: Date.now(),
            formatted_address: '290 Bremner Blvd, Toronto, ON M5V 3L9',
            name: 'CN Tower'
          },
          {
            created: Date.now(),
            formatted_address: '290 Bremner Blvd, Toronto, ON M5V 3L9',
            name: 'CN Tower'
          }
        ]
      }
      const getTravelTimeAndDistance = httpsCallable(functions, 'getTravelTimeAndDistance')
      return getTravelTimeAndDistance(itemData)
          .then(res => {
            this.travelTimeAndDistance = res.data.travelTimeAndDistance
            console.log("Cold start successful")
          })
          .catch(err => {
            console.log(err)
          })
    },
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    listingData (state) {
      return state.listingData
    },
    listingItems (state) {
      return state.listingItems
    },
    activeListingId (state) {
      return state.activeListingId
    }
  }
}
